       

     
      <div class="row">

        <div class="col">
        <div class="card" style="width: 25rem;" [ngClass]="{'dark-bg' : isDark }">
          <div class="card-body"> 
            <div class="card-title">Company Logo</div>
            <form [formGroup]="logoForm"  (ngSubmit)="saveLogoButtonClick()" enctype="multipart/form-data">
              <div class="text-center">
                <img [src]="imageUrlLogo" width="250px" height="200px">
              </div>           
             <div class="form-group mt-2">
            <input [ngClass]="{'dark-input-field' : isDark }"  type="file" accept="image/*" formControlName="logo" class="form-control" (change)="onLogoSelected($event)">  
           </div> 
           <div class="form-group">
           <button type="submit" class="btn btn-success float-right">
            <span *ngIf ="showProcessingIndicatorLogo" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
             Save
            </button>
           </div> 
          </form>                 
          </div>
        </div>
      </div>
      <div class="col">
        <div class="card" style="width: 25rem;" [ngClass]="{'dark-bg' : isDark }">
          <div class="card-body"> 
            <div class="card-title">Signature</div>
            <form [formGroup]="signatureForm"  (ngSubmit)="saveSignatureButtonClick()" enctype="multipart/form-data">
              <div class="text-center">
                <img [src]="imageUrlSignature"  width="250px" height="200px">
              </div>           
             <div class="form-group mt-2">
            <input [ngClass]="{'dark-input-field' : isDark }"  type="file" accept="image/*" formControlName="signature" class="form-control" (change)="onSignatureSelected($event)">  
           </div> 
           <div class="form-group">
           <button type="submit" class="btn btn-success float-right">
            <span *ngIf ="showProcessingIndicatorSignature" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
             Save
            </button>
           </div> 
          </form>                 
          </div>
        </div>
      </div>

      </div>

      <br>

      <!-- <div class="row">
        <div class="col">
        <div class="card"  style="width: 25rem;"  [ngClass]="{'dark-bg' : isDark }">
          <div class="card-body">
            <div class="form-group">
              <label for="defaultCompany" class="col-form-label">Default Company</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-bank"></i></span>
                </div>
                <select [ngClass]="{'dark-input-field' : isDark }"  [(ngModel)]="defaultCompany" class="form-control field-bg-color">        
                  <option [ngValue]="null">-Select-</option>
                  <option >
                   
                  </option>
              </select>
              </div>           
            </div>
            <div class="form-group">
            <button type="button"  class="btn btn-success float-right">
              <span *ngIf ="showProcessingIndicatorDefaultCompany " class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
               Save
            </button>
            </div>
        </div>
      </div>
      </div>
      </div> -->

     
        


